import { Modal } from "@/components/bootstrap/TemporaryReactstrapCompatibilityLayer";
import Button from "../../layout/Button";

const ConfirmDeleteModal = ({
  show = false,
  onConfirm,
  onCancel,
  message,
  header,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  hideActions = false,
}) => {
  const containerStyle = hideActions ? { height: 210 } : undefined;

  return (
    <Modal
      isOpen={show}
      className="modal-config confirm-delete-modal"
      centered
      backdrop="static"
      fade={false}
    >
      <div className="confirm-delete-modal-container" style={containerStyle}>
        <div className="confirm-delete-modal-header-container">
          <div className="confirm-delete-modal-header">{header}</div>
        </div>

        <div className="confirm-delete-modal-body">{message}</div>

        {!hideActions && (
          <>
            <Button
              label={cancelLabel}
              className="confirm-delete-modal-cancel-button"
              clickHandler={onCancel}
            />
            <Button
              label={confirmLabel}
              className="confirm-delete-modal-confirm-button"
              clickHandler={onConfirm}
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
